import { render, staticRenderFns } from "./positionDialog.vue?vue&type=template&id=57558f72&scoped=true"
import script from "./positionDialog.vue?vue&type=script&lang=js"
export * from "./positionDialog.vue?vue&type=script&lang=js"
import style0 from "./positionDialog.vue?vue&type=style&index=0&id=57558f72&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57558f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57558f72')) {
      api.createRecord('57558f72', component.options)
    } else {
      api.reload('57558f72', component.options)
    }
    module.hot.accept("./positionDialog.vue?vue&type=template&id=57558f72&scoped=true", function () {
      api.rerender('57558f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/positionDialog.vue"
export default component.exports